import {
  call, put, takeEvery, takeLatest, all,
} from 'redux-saga/effects';
import { apiWithUrlParams } from '../apiMiddleware/apiMiddleware';
import * as types from '../constants';
import { getFilteredSportList, sortSportsPosition } from '../utils/sports';

function* filteredByLive(action) {
  const { live } = action;
  yield put({ type: types.FILTER_LIVE, live });
}

function* getSportsList(action) {
  try {
    const urlParams = {
      date: action.date.get('value'),
      pref: action.pref,
    };
    const { data } = yield call(apiWithUrlParams, 'hublive', 'getSportsList', urlParams);
    const { sports, promohighlighted } = data;
    yield put({ type: types.GET_SPORTS_LIST_SUCCESS });
    yield put({ type: types.SET_PROMO_HIGHLIGHTED, promohighlighted });

    const filteredSportList = getFilteredSportList(sports);

    yield all(filteredSportList.map(sport => put({ type: types.SET_AVAILABLE_SPORT, sport })));
    yield put({ type: types.SORT_SPORTS_LIST });
    yield all(filteredSportList
      .filter(sport => sport.isAvailable)
      .sort((a, b) => sortSportsPosition(a, b))
      .map(sport => put({
        type: types.GET_COMPETITIONS_LIST_REQUEST, date: action.date, sportId: sport.sportId, pref: urlParams.pref,
      })));
  } catch (error) {
    yield put({ type: types.GET_SPORTS_LIST_ERROR, error });
  }
}

function* watchGetSportsList() {
  yield takeEvery(types.GET_SPORTS_LIST_REQUEST, getSportsList);
}

function* getCompetitionsList(action) {
  try {
    const urlParams = {
      date: action.date.get('value'),
      id: action.sportId,
      pref: action.pref,
    };

    if (action.sportId === '3' && process.env.REACT_APP_SITE === 'corriere') {
      return;
    }
    if ((action.sportId === '8' || action.sportId === '6C' || action.sportId === '6M') && (process.env.REACT_APP_SITE === 'fcinter' || process.env.REACT_APP_SITE === 'calcionapoli1926' || process.env.REACT_APP_SITE === 'forzaroma')) {
      return;
    }
    const { data } = yield call(apiWithUrlParams, 'hublive', 'getCompetitionsList', urlParams);

    yield put({ type: types.GET_COMPETITIONS_LIST_SUCCESS, data, sportId: action.sportId });
    yield put({ type: types.GET_HIGHLIGHTED_COMPETITIONS_LIST_SUCCESS, data, sportId: action.sportId });
    yield put({ type: types.SET_COMPETITION_LOADED, data, sportId: action.sportId });
    yield filteredByLive(action);
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error(`Something went wrong while fetching data for sportId ${action.sportId} \n`, error);
    yield put({ type: types.GET_COMPETITIONS_LIST_ERROR, error: error.message });
  }
}

function* watchGetCompetitionsList() {
  yield takeEvery(types.GET_COMPETITIONS_LIST_REQUEST, getCompetitionsList);
}

function* getFilteredByDate(action) {
  const urlParams = {
    date: action.date,
    pref: process.env.REACT_APP_SITE,
  };
  yield getSportsList(urlParams);
  yield put({ type: types.FILTER_DATETIME_SUCCESS, date: action.date });
}

function* watchGetFilteredByDate() {
  yield takeLatest(types.FILTER_DATETIME, getFilteredByDate);
}

function* locationChange() {
  yield put({ type: types.CLEAR_SORTED_SPORTS });
}

function* watchLocationChange() {
  yield takeEvery('@@router/LOCATION_CHANGE', locationChange);
}

export default [
  watchGetSportsList,
  watchGetCompetitionsList,
  watchGetFilteredByDate,
  watchLocationChange,
];
